<template>
  <div style="padding: 10px" class="bloc">
    <div v-for="(questionId,id) in questionsId" :key="id">
      <div style="margin-top:5px;padding:5px; border:1px solid #e6ecf0">
      <BarChart
        style="margin-left:-11px"
        ref="barchart"
        :id="id"
        :questionId="questionId"
        v-if="Object.keys(sondage_data_resultats).some(id=>id===questionId) && sondage_vue_type_resultats === 'bar'"
        :donnees="sondage_data_resultats[questionId]"
      />
      <br>
      <PieChart
        style="margin-left: -11px"
        ref="piechart"
        :id="id"
        :questionId="questionId"
        v-if="Object.keys(sondage_data_resultats).some(id=>id===questionId) && sondage_vue_type_resultats === 'pie'"
        :resultatQueston="sondage_data_resultats[questionId]"
      />

      <br />
      <LibreResultats
        v-if="Object.keys(sondage_libre_resultats).some(id=>id===questionId)"
        :intitule="sondage_libre_resultats[questionId].intitule"
        :reponses="sondage_libre_resultats[questionId]"
      />
      </div>
    </div>

  </div>
</template>

<script>
import BarChart from '@/components/resultats/charts/BarChart'
import PieChart from './charts/PieChart'
import StarRating from 'vue-star-rating'
import LibreResultats from './LibreResultats'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AllResultats',
  components: {
    BarChart,
    PieChart,
    StarRating,
    LibreResultats
  },
  data () {
    return {
      currentSlide: 0,
      arrayOfResults: []
    }
  },
  computed: {
    ...mapGetters([
      'type_formulaire',
      'sondage_vue_resultats',
      'sondage_vue_type_resultats',
      'sondage_data_resultats',
      'sondage_libre_resultats'
    ]),
    questionsId: function () {
      let arrayDataChart = Object.keys(this.sondage_data_resultats)
      let arrayDataReponsesLibre = Object.keys(this.sondage_libre_resultats)
      let questionsId = arrayDataChart.concat(arrayDataReponsesLibre)
      questionsId.sort()
      return questionsId
    }
  },
  created () {
    this.$store.commit('UNSET_CHARTS_REFS')
  },
  methods: {
    ...mapMutations({
      vueSlider: 'SET_VUE_RESULTATS_SLIDER'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/AllResultats.vue